<template>
  <router-view/>
</template>

<script setup lang="ts">
// 暂时注释掉可能导致问题的store访问，等系统稳定后再逐步恢复
// import { ref, computed, onMounted, onUnmounted } from 'vue'
// import { useFriendStore } from './store/friend'
// import { useSocketStore } from './store/socket'
// import { useUserStore } from './store/user'

// const friendStore = useFriendStore()
// const socketStore = useSocketStore()
// const userStore = useUserStore()

// Lifecycle
// onMounted(async () => {
//   if (!userStore.userInfo.userId && !userStore.userInfo.id) {
//     await userStore.fetchUserInfo()
//   }
//   socketStore.connect()
//   friendStore.bindWsHandlers(socketStore) 

//   await Promise.all([
//     friendStore.loadFriends(),
//     friendStore.loadGroups(),
//     friendStore.loadPendingRequests(),
//   ])

//   const ids = (friendStore.friends || []).map(f => f.user_id).filter(Boolean)
//   if (ids.length) socketStore.requestFriendStatus(ids)
// })

// onUnmounted(() => {
//   socketStore.disconnect()
// })
</script>

<style>
html, body {
  margin: 0;
  padding: 0;
  overflow-y: auto;
}
</style>